import { Center, Loader, Paper } from "@mantine/core";
import { warehouseApi } from "apis";
import { Loading } from "components";
import { ErrorStatusType } from "constants/types/common";
import { WarehouseResponseType } from "constants/types/warehouse";
import { useFormik } from "formik";
import { FORM_IDS } from "pages/Warehouse/config";
import { FC, useState } from "react";
import { useNotification } from "utils/hooks";
import { editValidationSchema } from "./config";
import WarehouseFormFields from "../WarehouseFormFields/WarehouseFormFields";

interface EditFormProps {
  warehouse: WarehouseResponseType;
  onClose?: () => void;
  mutate?: () => void;
}

const EditForm: FC<EditFormProps> = ({ warehouse, onClose, mutate }) => {
  const { notification } = useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik({
    initialValues: {
      name: warehouse.name,
      isActive: warehouse.isActive,
    },
    validationSchema: editValidationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        const res = await warehouseApi.update(warehouse.id, values);
        if (res.data.success) {
          notification.success({ title: "Cập nhật nhà kho thành công" });
          onClose?.();
          mutate?.();
        }
      } catch (error: ErrorStatusType | any) {
        notification.error({ title: "Cập nhật nhà kho thất bại", message: error?.error?.message });
      }
      setIsLoading(false);
    },
  });

  return (
    <Loading variant="overlay" visible={isLoading}>
      <Paper>
        <form id={FORM_IDS.EDIT} onSubmit={formik.handleSubmit}>
          <WarehouseFormFields formik={formik} />
        </form>
      </Paper>
    </Loading>
  );
};

export default EditForm;
